// @flow
import api from 'tim-api';
import { goalsTransfer as goalsTransferEndPoint } from 'endPoints';

export const state = {
  goalsTransfer: [],
  isEditable: ''
};

export const getters = {
  goalsTransfer: (state: Object) => state.goalsTransfer,
  isEditable: (state: Object) => state.isEditable
};

export const mutations = {
  SET_GOALS_TRANSFER(state: Object, goalsTransfer: Array<Object>) {
    state.goalsTransfer = goalsTransfer;
  },
  SET_IS_EDITABLE(state: Object, isEditable: Boolean) {
    state.isEditable = isEditable;
  }
};

export const actions = {
  fetchGoalTransfer({ commit }: Action) {
    return api.get(`${goalsTransferEndPoint}/between-channels`).then(({ data }) => {
      commit('SET_GOALS_TRANSFER', data.data);
      commit('SET_IS_EDITABLE', data.editable);
    });
  },
  updateGoalsTransfer({ commit }: Action, goals: Object) {
    return api.put(`${goalsTransferEndPoint}/between-channels`, goals)
      .then(({ data }) => {
        commit('SET_GOALS_TRANSFER', data);
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
